import arrowLeft from './images/arrow-left.svg'
import arrowRight from './images/arrow-right.svg'

export const Pagination = ({ tableLib, sizes, canLoadMore, manualPagination }) => (
    <footer className="pagination d-flex justify-content-between mt-2">
        <span
            disabled={!tableLib.getCanPreviousPage()}
            onClick={tableLib.previousPage}
            className={`d-flex align-items-center pointer ${!tableLib.getCanPreviousPage() ? 'disabled' : ''}`}
        >
            <img src={arrowLeft} />
            <span>Precendente</span>
        </span>
        <div className='indicator'>
            <span>{`Pagina ${tableLib.getState().pagination?.pageIndex + 1
            } di ${canLoadMore && manualPagination ? 'Molte' : tableLib.getPageCount()}`}</span>
            <span className='ms-2'>Mostrati: </span>
            <select
                value={tableLib.getState().pageSize}
                onChange={(e) => tableLib.setPageSize(parseInt(e.target.value, 20))}
                id="pagiation"
            >
                {sizes.map((size) => (
                    <option key={size} value={size}>
                        {size}
                    </option>
                ))}
            </select>
            <span> risultati per pagina</span>
        </div>
        <span disabled={manualPagination ? !canLoadMore : !tableLib.getCanNextPage()} 
            className={`d-flex align-items-center pointer ${(manualPagination && !canLoadMore) || (!manualPagination && !tableLib.getCanNextPage()) ? 'disabled' : ''}`} 
            onClick={tableLib.nextPage}
        >
            <span>Successivo</span>
            <img src={arrowRight} />
        </span>
    </footer>
);
